module.exports = __webpack_public_path__ + "img/teeth-33.4692e154.png";